export default __webpack_public_path__ + "static/media/1991.4f9baa62.png";